import * as React from "react";

// style, design
import Calendar from "../../components/Calendar/Calendar";

export default () => {
  return <Calendar />;
};
